import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_6.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/promote');
  const shareText = encodeURIComponent('Inclusive Culture – Promote diversity and ensure every voice is valued!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Inclusive Culture — Outstanding Workplaces</title>
        <meta property="og:title" content="Inclusive Culture — Outstanding Workplaces" />
        <meta property="og:description" content="Inclusive Culture – Promote diversity and ensure every voice is valued" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777961078/i_6_yauyuk.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/promote" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Inclusive Culture — Outstanding Workplaces" />
        <meta name="twitter:description" content="Inclusive Culture – Promote diversity and ensure every voice is valued" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1777961078/i_6_yauyuk.jpg" />
      </Helmet>

                     
    <div className="sight_6_page_wrapper">
      <div className="sight_6_content_container">

        <div className="sight_6_section_one">

          {/* TITLE */}
          <h1 className="sight_6_page_title">
            Inclusive Culture – Promote diversity and ensure every voice is valued
          </h1>

          {/* ROW */}
          <div className="sight_6_row">

            {/* LEFT SIDE */}
            <div className="sight_6_left">
              <div className="sight_6_image_wrapper">
                <img
                  src="/assets/i_6.jpg"
                  alt="Team meeting discussion"
                  className="sight_6_blog_image"
                />
              </div>

                {/* SHARE SECTION */}
                <div className="sight_6_share_section">
                  <span className="sight_6_share_text">Share :</span>
                  <div className="sight_6_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_6_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_6_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_6_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_6_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

               <p className="sight_6_intro_paragraph">
                Building an inclusive culture means creating a workplace where diversity is embraced, and every employee feels heard, respected, and valued. This approach not only fosters a sense of belonging but also drives collaboration, innovation, and overall organizational performance. By actively promoting equity and inclusion, companies can cultivate a positive environment that motivates employees to contribute their best.
              </p>
            </div>

            {/* RIGHT SIDE */}
            <div className="sight_6_right">
              <div className="sight_6_ad_card">
                <img src="/assets/bc_1.png" className="sight_6_ad_bg" />
                <div className="sight_6_ad_overlay"></div>

                <img src="/assets/bg_1.png" className="sight_6_ad_badge" />

                <div className="sight_6_ad_content">
                  <h2>
                    Earn the Outstanding <br />
                    <span>Workplaces Certification</span>
                  </h2>

                  <ul>
                    <li>Attract Top Talent</li>
                    <li>Boost Employee Engagement</li>
                    <li>Drive Culture-Led Growth</li>
                  </ul>

                    <button 
  className="sight_6_ad_btn"
  onClick={() => window.location.href = '/nominate'}
>
  Get Certificate
</button>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* SECTION TWO */}
        <div className="sight_6_section">

          <div className="sight_6_topics">

            <div className="sight_6_topic_item">
              <h2 className="sight_6_topic_heading">What Inclusive Culture Really Means</h2>
              <ul className="sight_6_topic_list">
                <li>Define inclusive culture versus diversity — and why inclusion is what allows diverse voices to be valued and heard.</li>
                <li>Cover inclusive language, equal opportunity, and open dialogue.</li>
              </ul>
            </div>

            <div className="sight_6_topic_item">
              <h2 className="sight_6_topic_heading">Best Practices to Cultivate Inclusivity at Work</h2>
              <ul className="sight_6_topic_list">
                <li>Practical steps like training programs, diverse leadership development, safe spaces, and continuous measurement of progress.</li>
              </ul>
            </div>

            <div className="sight_6_topic_item">
              <h2 className="sight_6_topic_heading">Nurturing Diversity, Belonging & Psychological Safety</h2>
              <ul className="sight_6_topic_list">
                <li>Explore characteristics that make workplaces truly inclusive: psychological safety, respect for differences, and empowered employees.</li>
              </ul>
            </div>

            <div className="sight_6_topic_item">
              <h2 className="sight_6_topic_heading">⁠ ⁠Inclusive Communication: How to Listen and Respond</h2>
              <ul className="sight_6_topic_list">
                <li>Strategies for active listening, open feedback channels, and ensuring every voice counts.</li>
                <li>This can include tips for meetings, one-to-ones, and cross-team communication.</li>
              </ul>
            </div>

            <div className="sight_6_topic_item">
              <h2 className="sight_6_topic_heading">Training & Education for Inclusion Awareness</h2>
              <ul className="sight_6_topic_list">
                <li>Why unconscious bias training, DEI workshops, and cultural competence sessions matter — and how to implement them.</li>
              </ul>
            </div>

            <div className="sight_6_topic_item">
              <h2 className="sight_6_topic_heading">Real Examples of Inclusive Companies & Practices</h2>
              <ul className="sight_6_topic_list">
                <li>Showcase how organizations (e.g., leadership training, ERGs, mentorship programs) build inclusion — with examples readers can emulate.</li>
              </ul>
            </div>

            <div className="sight_6_topic_item">
              <h2 className="sight_6_topic_heading">Employee Resource Groups & How They Boost Culture</h2>
              <ul className="sight_6_topic_list">
                <li>Explain what ERGs are, how to start them, and how they strengthen community, belonging, and engagement.</li>
              </ul>
            </div>

            <div className="sight_6_topic_item">
              <h2 className="sight_6_topic_heading">Inclusive Policies That Make a Difference</h2>
              <ul className="sight_6_topic_list">
                <li>Discuss flexible work options, equitable pay structures, accessibility, and supportive HR policies that create a culture of fairness.</li>
              </ul>
            </div>

            <div className="sight_6_topic_item">
              <h2 className="sight_6_topic_heading">Celebrating Diversity: Events, Heritage, and Belonging</h2>
              <ul className="sight_6_topic_list">
                <li>Ideas to celebrate cultural festivals, heritage months, and individual identities in ways that foster belonging.</li>
              </ul>
            </div>

            <div className="sight_6_topic_item">
              <h2 className="sight_6_topic_heading">⁠How Inclusive Culture Improves Performance & Retention</h2>
              <ul className="sight_6_topic_list">
                <li>Tie inclusivity to business outcomes like employee engagement, innovation, retention, and talent attraction.</li>
              </ul>
            </div>

          </div>
        </div>

       </div>
   </div>
    </>
  );
}

export default BlogPage;




